import * as React from 'react';
import { EStarSize, Stars } from '@cian/frontend-reviews-components';
import { ArticleHeading5 } from '@cian/ui-kit';
import * as style from './NewbuildingReviewsStat.css';

export const NewbuildingEmptyReviewsStat: React.FC = () => {
  return (
    <div className={style['review']}>
      <Stars value={0} size={EStarSize.M} />
      <ArticleHeading5 color="text-inverted-default">Нет отзывов</ArticleHeading5>
    </div>
  );
};
